import Form from 'react-bootstrap/Form'

const ListOptions = ({selected,onChange,accountType,align="center",flow='row'})=>{
  const options = [
    {
      label:'All Foods',
      value:'all_foods',
      accountTypes:['gym','trainer','client']
    },{
      label:'Top Foods',
      value:'top_foods',
      accountTypes:['gym','trainer','client']
    },{
      label:'Generic Foods',
      value:'generic_foods',
      accountTypes:['gym','trainer','client']
    },{
      label:'My Foods',
      value:'my_foods',
      accountTypes:['gym','trainer','client']
    },{
      label:'My Trainer\'s foods',
      value:'my_trainer_foods',
      accountTypes:['client']
    },{
      label:'My Gym\'s foods',
      value:'my_gym_foods',
      accountTypes:['client','trainer']
    }
  ]
  //these options do not allow other options to be checked
  //at the same time
  const exclusiveListOptions = ['all_foods','top_foods']
  const handleCheck = value => {
    const update = (
      selected.includes(value)
      //iff the value is already selected then un-toggle it
      ? selected.filter( s => s !== value )
      //otherwise add it to the list of selected. BUT, if selecting all foods
      //uncheck all other foods. otherwise check the food box and uncheck all foods
      //ie all_foods causes all other check boxes to become unchecked and checking any
      //other checkbox will cause all foods to become unchecked
      : (exclusiveListOptions.includes(value) ? [value] : [...selected,value].filter(s=> !exclusiveListOptions.includes(s)))
    )
    localStorage.setItem("listTypes", JSON.stringify(update))
    onChange(update)
  }
  return (
    <div>
      <div className={`d-flex align-items-${align} flex-wrap flex-${flow}`}>
        {
          options
            .filter(o=>o.accountTypes.includes(accountType))
            .map(({label,value})=>(
              <Form.Check  
                className="m-1"
                onChange={()=>{
                  handleCheck(value)
                }}
                checked={selected.includes(value)}
                id={`list-select-check-${value}`}
                label={label}
              />
            ))
        }
      </div>
      {selected.length === 0&&
        <small className='text-muted'>
          Please select at least one option
        </small>
      }
    </div>
  )
}

export default ListOptions